import jsonToJsxComponent from '../jsonToJsxComponent';
import FooterJson from './Footer.json';

const Footer = jsonToJsxComponent(FooterJson);

// eslint-disable-next-line import/prefer-default-export
export { Footer };
